import { Config } from '../config';

export const isNotDev = () => window.location.hostname !== 'localhost';

// US production: 'us' is new, 'beta' is deprecated but still functional
export const isUSprod = () => isNotDev() && (Config.StageName === 'us' || Config.StageName === 'beta');

export const isNotUSprod = () => !isUSprod();

export const isStaging = () => isNotDev() && Config.StageName === 'staging';

export const isTest = () => isNotDev() && Config.StageName === 'test';

export const isEUprod = () => isNotDev() && (Config.StageName === 'eupilot' || Config.StageName === 'euprod');

export const isUKprod = () => isNotDev() && Config.StageName === 'ukprod';

export const isNotProd = () => !isEUprod() && !isUSprod() && !isUKprod();
